import styled from 'styled-components';

export const MapPathStyled = styled.path`
  cursor: pointer;
  transition: fill 0.4s;
`;
